import { type PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { useCheckAuthenticated } from '@/lib/auth/hooks/useCheckAuthenticated';
import { useUser } from '@/lib/auth/useUser';
import { combinePathAndQuery } from '@/utils/combinePathAndQuery';
interface RedirectWhenUnauthenticatedProps {
  redirectPath: string;
  callbackUrl?: string;
}

/**
 * 인증되지 않은 사용자를 리다이렉트하는 컴포넌트
 * 인증 상태 확인 및 리다이렉트 로직만 담당
 */
export const RedirectWhenUnauthenticated = ({
  children,
  redirectPath,
  callbackUrl = ''
}: PropsWithChildren<RedirectWhenUnauthenticatedProps>) => {
  const router = useRouter();
  const {
    isAuthenticated,
    isInitialized
  } = useUser();
  useCheckAuthenticated(() => {
    const resolvedCallbackUrl = callbackUrl ? combinePathAndQuery(callbackUrl, {
      ...router.query
    }) : router.asPath;
    void router.push({
      pathname: redirectPath,
      query: {
        callbackUrl: resolvedCallbackUrl
      }
    });
  });

  // 초기화 중이거나 인증되지 않았으면 렌더링하지 않음
  if (!isInitialized || !isAuthenticated) return null;
  return <>{children}</>;
};